import { render, staticRenderFns } from "./icon-justify-center.vue?vue&type=template&id=98cfeca4"
import script from "./icon-justify-center.vue?vue&type=script&lang=js"
export * from "./icon-justify-center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports